import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  const disconnects = ['Tu intuición', 'Tu calma', 'Tu magnetismo natural', 'Tu capacidad de recibir'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-193">
      <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-brown-light/20 blur-3xl" data-id="element-194" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-195">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-196">
          <div data-id="element-197">
            <FadeIn data-id="element-198">
              <h2 className="text-3xl md:text-4xl font-serif mb-8 text-gold leading-tight" data-id="element-199">
                El problema no es falta de disciplina ni de ganas.
              </h2>
              <div className="space-y-6 text-lg text-cream/80 leading-relaxed" data-id="element-200">
                <p data-id="element-201">
                  Te han hecho creer que tienes que hacer más, esforzarte más,
                  controlar más. Pero ese es exactamente el problema.
                </p>
                <p className="text-xl font-serif text-cream italic border-l-2 border-gold pl-6 py-2" data-id="element-202">
                  Estás viviendo en exceso de energía masculina: control, hacer,
                  sostener, resolver.
                </p>
                <p data-id="element-203">
                  Esa armadura te sirvió para sobrevivir, pero hoy te está
                  ahogando. Te mantiene en alerta constante y bloquea tu
                  verdadera fuerza.
                </p>
              </div>
            </FadeIn>
          </div>

          <div data-id="element-204">
            <FadeIn delay={0.2} data-id="element-205">
              <div className="bg-cream text-brown p-8 md:p-12 rounded-3xl shadow-2xl" data-id="element-206">
                <div className="flex items-center mb-8" data-id="element-207">
                  <Sparkles className="w-8 h-8 text-gold-dark mr-4" data-id="element-208" />
                  <h3 className="text-2xl font-serif" data-id="element-209">
                    Ese exceso de control te desconecta de:
                  </h3>
                </div>

                <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
                once: true
              }} className="space-y-6" data-id="element-210">
                  {disconnects.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-center" data-id="element-211">
                      <div className="w-8 h-px bg-gold mr-4" data-id="element-212" />
                      <span className="text-xl font-serif text-brown-light font-bold" data-id="element-213">
                        {item}
                      </span>
                    </motion.li>)}
                </motion.ul>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}